import React, { Component } from "react"
import { Input, Button, Icon, Affix, Table, Row, message, Menu, DatePicker } from "antd"
import { Link, withRouter } from "react-router-dom"
import { observer, inject } from "mobx-react"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import closeIcon from "app/styles/images/sp/close.svg"
// import cx from "classnames"
import { disposeFilename } from "app/vendor/util"
import queryString from 'query-string'
import moment from "moment"

const RangePicker = DatePicker.RangePicker
const { Search } = Input

@inject("auth", "store") @observer
class DataHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDownloadModal: false,
      dayKey: "-1",
    }
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  componentDidMount() {
    const { location } = this.props
    if (location.search) {
      this.setState({
        inputSearch: queryString.parse(location.search).keywords
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps
    if (nextLocation.search !== location.search) {
      this.setState({
        inputSearch: queryString.parse(nextLocation.search).keywords
      })
    }
  }

  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords,
    })
  }

  searchData = () => {
    const { history, match } = this.props
    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({ keywords: this.state.inputSearch })
    })
  }

  showDownloadModal = () => {
    // 拉下载链接
    const { getDownloadLinks, selectedData } = this.props.store
    const dataIds = selectedData.slice().map(item =>
      item.id
    )
    getDownloadLinks(dataIds)
      .then(
        res => {
          this.props.store.downloadInfo = res
          this.setState({
            showDownloadModal: true
          })
        },
        err => {
          message.error(err.message)
        }
      )
  }

  copyDownloadLinks = (downloadLinks) => {
    let targetId = "_hiddenCopyText_"
    let downloadLinkString = ""
    let currentFocus = document.activeElement
    let target = document.getElementById(targetId)
    currentFocus.focus()

    for (let i = 0; i < downloadLinks.length; i++) {
      downloadLinkString = downloadLinkString + downloadLinks[i] + "\n"
    }

    // 如果不是，则使用节点的textContent
    if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
    }
    target.textContent = downloadLinkString
    // 聚焦目标节点，选中它的内容
    target.focus()
    target.setSelectionRange(0, target.value.length)

    // 进行复制操作
    try {
      document.execCommand("copy")
      message.success("复制链接成功")
    } catch (e) {
      message.error("复制链接失败")
    }

    // 不再聚焦
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus()
    }

    // 清空临时数据
    target.textContent = ""
  }

  render() {
    const { selectedData, downloadLinks, downloadInfo } = this.props.store
    const { showDownloadModal, inputSearch } = this.state
    // const hasSelectedData = selectedData.length > 0
    // const downloadBtnClass = cx({
    //   "download-btn": true,
    //   "disable": !hasSelectedData
    // })
    const columns = [
      {
        title: (
          <div className="ta-l file-name-title">文件名称</div>
        ),
        dataIndex: "filename",
        render: function (title, record, index) {
          const { front, end } = disposeFilename(title)

          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={title}
            >
              <Row className="filename" type="flex">
                <div className="ellipsis filename-front">
                  {front}
                </div>
                <div className="filename-end">{end}</div>
              </Row>
            </MaterialTip>
          )
        }
      }, {
        width: 200,
        title: "数据样本名",
        dataIndex: "sampleName",
      }, {
        width: 50,
        title: (<div className="ta-c">操作</div>),
        dataIndex: "oprator",
        render: (text, record, index) => {
          return (
            <div className="ta-c">
              <a href={downloadInfo[record.id]}>
                <Icon className="download-btn cursor-p" type="download" />
              </a>
            </div>
          )
        }
      }
    ]

    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="search-bar affix-line">
            <div className="pull-left">
              <Search
                value={inputSearch}
                placeholder="输入文件名/样本名搜索"
                size="large"
                onChange={this.changeSearch}
                onSearch={this.searchData}
              />
            </div>
            <div className="pull-right">
              {/* <span>已选 <span className="selected-num">{selectedData.length}</span> 条数据</span>
              <Button
                disabled={hasSelectedData ? "" : "disabled"}
                className={downloadBtnClass}
                type="primary"
                size="default"
                onClick={this.showDownloadModal}
              >
                <Icon type="download" />下载
              </Button> */}
              <Link to="/jab/pgs/entrance">
                <Button type="primary" size="default" ><Icon type="upload" />数据上传 </Button>
              </Link>
            </div>
          </div>
          {this.renderDayMenu()}
        </div>
        <MaterialModal
          className="pgs-datamanage-download-modal"
          width={636}
          title="数据下载"
          buttonText="复制下载链接"
          action={() => this.copyDownloadLinks(downloadLinks)}
          visible={showDownloadModal}
          buttonType="primary">
          <img
            className="pgx-modal-close"
            src={closeIcon}
            alt="关闭对话框"
            onClick={() => this.closeModal("showDownloadModal")}
          />
          <Table
            className="download-table"
            columns={columns}
            rowKey={record => record.id}
            dataSource={selectedData.slice()}
            pagination={false}
            scroll={{ x: true, y: 153 }}
          />
          <div className="md5-download">
            <span className="title-bold">MD5文件下载：</span>
            <div className="md5-url">
              {downloadInfo['md5Url']}
              <a href={downloadInfo['md5Url']}>
                <Icon
                  className="download-btn cursor-p"
                  type="download"
                />
              </a>
            </div>
          </div>
          <div className="download-links-wrap">
            <div className="download-links" id="downloadLinks">
              {
                downloadLinks.map((link, index) =>
                (
                  <div className="download-link" key={index}>
                    {link}
                  </div>
                )
                )
              }
            </div>
          </div>
          <Row type="flex" justify="center" className="tip-message">请点击下方“复制下载链接”按钮，将复制的链接24小时内粘贴至迅雷等下载工具进行批量下载</Row>
        </MaterialModal>
      </Affix>
    )
  }

  onDataChange = (e, type) => {
    this.props.store.tableData = []

    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.props.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.props.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.props.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  renderDayMenu = () => {
    return (
      <div className="search-time-bar affix-line">
        <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.onDataChange}
          disabledDate={this.disabledDate}
        />
      </div>
    )
  }
}

export default withRouter(DataHeader)



// WEBPACK FOOTER //
// ./src/app/pages/ecs/data_manage/containers/DataHeader.js